// Meeting times are handled as a naive wall-clock that the backend stores in
// UTC — e.g. a 10:00 (Amman) meeting is stored/sent as "...T10:00:00.000Z".
// This matches the mobile app + backend. So for DISPLAY we read the UTC fields,
// and when SENDING we build the UTC fields from the picked local wall-clock.
// (Previously this file shifted everything by a hardcoded Amman +180, which
// double-counted the offset and disagreed with the mobile app.)

const pad = (n) => (n < 10 ? `0${n}` : `${n}`);

const formatTime = (d) => {
  let h = d.getUTCHours();
  const m = pad(d.getUTCMinutes());
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${m} ${ampm}`;
};

export const formatDate = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const datePart = `${start.getUTCFullYear()}-${pad(
    start.getUTCMonth() + 1
  )}-${pad(start.getUTCDate())}`;
  return `${datePart} ${formatTime(start)} - ${formatTime(end)}`;
};

// A picked LOCAL Date → a Date whose toISOString() carries the same wall-clock
// digits as UTC (10:00 picked → "...T10:00:00.000Z"). Used before sending.
export const toWallClockDate = (localDate) =>
  new Date(
    Date.UTC(
      localDate.getFullYear(),
      localDate.getMonth(),
      localDate.getDate(),
      localDate.getHours(),
      localDate.getMinutes(),
      0
    )
  );

// A stored wall-clock-UTC ISO → a LOCAL Date with the same digits, so a local
// date picker shows the intended time (not shifted). Used when editing.
export const fromWallClockDate = (iso) => {
  const d = new Date(iso);
  return new Date(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes()
  );
};
